module.exports = __webpack_public_path__ + "img/Weapon_05.5a50fef9.png";